import React from 'react';

type PageStateTone = 'info' | 'error';

type PageStateAction = {
    label: string;
    onClick: () => void;
};

export interface PageStateProps {
    title: string;
    description?: React.ReactNode;
    tone?: PageStateTone;
    primaryAction?: PageStateAction;
    secondaryAction?: PageStateAction;
}

const PageState: React.FC<PageStateProps> = ({title, description, tone = 'info', primaryAction, secondaryAction}) => {
    return (
        <div className="flex items-center justify-center min-h-96" role={tone === 'error' ? 'alert' : undefined}>
            <div className="text-center max-w-lg">
                <h2 className="text-xl font-semibold text-mld-text-primary mb-2">{title}</h2>
                {description ? <div className="text-gray-600 mb-4">{description}</div> : null}
                {primaryAction || secondaryAction ? (
                    <div className="flex flex-wrap justify-center gap-3">
                        {primaryAction ? (
                            <button
                                type="button"
                                onClick={primaryAction.onClick}
                                className="px-4 py-2 bg-mld-primary text-white rounded-lg hover:bg-mld-primary/90 transition-colors cursor-pointer">
                                {primaryAction.label}
                            </button>
                        ) : null}
                        {secondaryAction ? (
                            <button
                                type="button"
                                onClick={secondaryAction.onClick}
                                className="px-4 py-2 border border-mld-panel-border text-mld-text-primary rounded-lg hover:border-mld-primary hover:text-mld-primary transition-colors cursor-pointer">
                                {secondaryAction.label}
                            </button>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

export default PageState;
